export const mSentryPublicDSN = import.meta.env.VITE_PUBLIC_SENTRY_INGEST || "https://2b9d49f2e83d87f42721cf70bffdabcf@o4505119804751872.ingest.us.sentry.io/4510421435351040";
